export class RestoreAzureInstanceDiskInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "providerDiskId",
            "baseName": "providerDiskId",
            "type": "string",
            "format": ""
        },
        {
            "name": "settings",
            "baseName": "settings",
            "type": "AzureDiskSettings",
            "format": ""
        },
        {
            "name": "adeEncryption",
            "baseName": "adeEncryption",
            "type": "AdeRestoreEncryptionConfig",
            "format": ""
        },
        {
            "name": "diskEncryptionSetId",
            "baseName": "diskEncryptionSetId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreAzureInstanceDiskInput.attributeTypeMap;
    }
    constructor() {
    }
}
